import { useCallback, useMemo } from "react";
import { FormikSwitchInput } from "src/components/Inputs/FormikSwitchInput";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import useRequiredHasuraRoles from "src/hooks/useRequiredHasuraRoles";
import * as OrgService from "src/services/orgService";
import { HasuraRole } from "src/types/hasuraRole";
import * as RD from "src/types/remoteData";
import { z } from "zod";

export const Form = () => {
  const isAvelaAdmin = useRequiredHasuraRoles([HasuraRole.ADMIN]);
  return (
    <FormikSwitchInput<"disabled" | "enabled">
      label="Match"
      name={"match.status"}
      checked={["enabled", ""]}
      unchecked={["disabled", ""]}
      direction="row"
      formLabelProps={{ fontSize: "md", alignItems: "center" }}
      isDisabled={!isAvelaAdmin}
    />
  );
};

export function useForm(): {
  initialValues: RD.RemoteData<Error, FormikType>;
  submit: (values: FormikType) => Promise<void>;
} {
  const { remoteData, update } =
    OrgService.useOrgConfig<OrgConfig.MatchConfig>("Match");
  const initialValues = useMemo(() => {
    return remoteData.map((config): FormikType => {
      if (config === null || config.disabled === true) {
        return {
          match: { status: "disabled" },
        };
      }

      return {
        match: { status: "enabled" },
      };
    });
  }, [remoteData]);

  const submit = useCallback(
    async (values: FormikType) => {
      await update({
        disabled: values.match.status === "disabled" ? true : false,
      });
    },
    [update]
  );
  return { initialValues, submit };
}

export const FormikSchema = z.object({
  match: z.object({
    status: z.union([z.literal("enabled"), z.literal("disabled")]),
  }),
});

export type FormikType = z.infer<typeof FormikSchema>;
